{
  "version": 1,
  "source": "PunksData.colorOf @ 0x9cF9...117C",
  "colorIdMin": 1,
  "colorIdMax": 221,
  "colors": {
    "1": {
      "hex": "#000000",
      "alpha": 255
    },
    "2": {
      "hex": "#0040FF",
      "alpha": 255
    },
    "3": {
      "hex": "#005580",
      "alpha": 255
    },
    "4": {
      "hex": "#0060C3",
      "alpha": 255
    },
    "5": {
      "hex": "#142C7C",
      "alpha": 255
    },
    "6": {
      "hex": "#1637A4",
      "alpha": 255
    },
    "7": {
      "hex": "#1A43C8",
      "alpha": 255
    },
    "8": {
      "hex": "#1A6ED5",
      "alpha": 255
    },
    "9": {
      "hex": "#1C1A00",
      "alpha": 255
    },
    "10": {
      "hex": "#229000",
      "alpha": 255
    },
    "11": {
      "hex": "#251409",
      "alpha": 255
    },
    "12": {
      "hex": "#26314A",
      "alpha": 255
    },
    "13": {
      "hex": "#281B09",
      "alpha": 255
    },
    "14": {
      "hex": "#2858B1",
      "alpha": 255
    },
    "15": {
      "hex": "#28B143",
      "alpha": 255
    },
    "16": {
      "hex": "#293E64",
      "alpha": 255
    },
    "17": {
      "hex": "#296434",
      "alpha": 255
    },
    "18": {
      "hex": "#2A2A2A",
      "alpha": 255
    },
    "19": {
      "hex": "#2C5195",
      "alpha": 255
    },
    "20": {
      "hex": "#2C9541",
      "alpha": 255
    },
    "21": {
      "hex": "#2D190C",
      "alpha": 255
    },
    "22": {
      "hex": "#2D6B62",
      "alpha": 255
    },
    "23": {
      "hex": "#311B0D",
      "alpha": 255
    },
    "24": {
      "hex": "#32412A",
      "alpha": 255
    },
    "25": {
      "hex": "#328DFD",
      "alpha": 255
    },
    "26": {
      "hex": "#352410",
      "alpha": 255
    },
    "27": {
      "hex": "#353535",
      "alpha": 255
    },
    "28": {
      "hex": "#36462D",
      "alpha": 255
    },
    "29": {
      "hex": "#382D1F",
      "alpha": 255
    },
    "30": {
      "hex": "#392312",
      "alpha": 255
    },
    "31": {
      "hex": "#3B210F",
      "alpha": 255
    },
    "32": {
      "hex": "#3C2413",
      "alpha": 255
    },
    "33": {
      "hex": "#3C5659",
      "alpha": 255
    },
    "34": {
      "hex": "#3C6827",
      "alpha": 255
    },
    "35": {
      "hex": "#3CC300",
      "alpha": 255
    },
    "36": {
      "hex": "#3D2F1E",
      "alpha": 255
    },
    "37": {
      "hex": "#42503A",
      "alpha": 255
    },
    "38": {
      "hex": "#43513B",
      "alpha": 255
    },
    "39": {
      "hex": "#463827",
      "alpha": 255
    },
    "40": {
      "hex": "#473929",
      "alpha": 255
    },
    "41": {
      "hex": "#485D5D",
      "alpha": 255
    },
    "42": {
      "hex": "#486F2B",
      "alpha": 255
    },
    "43": {
      "hex": "#4A1201",
      "alpha": 255
    },
    "44": {
      "hex": "#4B3C2A",
      "alpha": 255
    },
    "45": {
      "hex": "#4C4C4C",
      "alpha": 255
    },
    "46": {
      "hex": "#4F2C14",
      "alpha": 255
    },
    "47": {
      "hex": "#4F4538",
      "alpha": 255
    },
    "48": {
      "hex": "#502F05",
      "alpha": 255
    },
    "49": {
      "hex": "#506A65",
      "alpha": 255
    },
    "50": {
      "hex": "#507C33",
      "alpha": 255
    },
    "51": {
      "hex": "#51360C",
      "alpha": 255
    },
    "52": {
      "hex": "#515151",
      "alpha": 255
    },
    "53": {
      "hex": "#52321A",
      "alpha": 255
    },
    "54": {
      "hex": "#52422F",
      "alpha": 255
    },
    "55": {
      "hex": "#534C00",
      "alpha": 255
    },
    "56": {
      "hex": "#552F16",
      "alpha": 255
    },
    "57": {
      "hex": "#555555",
      "alpha": 255
    },
    "58": {
      "hex": "#562600",
      "alpha": 255
    },
    "59": {
      "hex": "#577149",
      "alpha": 255
    },
    "60": {
      "hex": "#584733",
      "alpha": 255
    },
    "61": {
      "hex": "#595959",
      "alpha": 255
    },
    "62": {
      "hex": "#596570",
      "alpha": 255
    },
    "63": {
      "hex": "#596D48",
      "alpha": 255
    },
    "64": {
      "hex": "#5B4933",
      "alpha": 255
    },
    "65": {
      "hex": "#5C390F",
      "alpha": 255
    },
    "66": {
      "hex": "#5C736B",
      "alpha": 255
    },
    "67": {
      "hex": "#5C7F91",
      "alpha": 255
    },
    "68": {
      "hex": "#5C8539",
      "alpha": 255
    },
    "69": {
      "hex": "#5C915F",
      "alpha": 255
    },
    "70": {
      "hex": "#5D2310",
      "alpha": 255
    },
    "71": {
      "hex": "#5D5D5D",
      "alpha": 255
    },
    "72": {
      "hex": "#5D7975",
      "alpha": 255
    },
    "73": {
      "hex": "#5D8B43",
      "alpha": 255
    },
    "74": {
      "hex": "#5E4C37",
      "alpha": 255
    },
    "75": {
      "hex": "#5E5757",
      "alpha": 255
    },
    "76": {
      "hex": "#5E7253",
      "alpha": 255
    },
    "77": {
      "hex": "#5F1D09",
      "alpha": 255
    },
    "78": {
      "hex": "#636363",
      "alpha": 255
    },
    "79": {
      "hex": "#645849",
      "alpha": 255
    },
    "80": {
      "hex": "#65523C",
      "alpha": 255
    },
    "81": {
      "hex": "#655E5E",
      "alpha": 255
    },
    "82": {
      "hex": "#683C08",
      "alpha": 255
    },
    "83": {
      "hex": "#68461F",
      "alpha": 255
    },
    "84": {
      "hex": "#690C45",
      "alpha": 255
    },
    "85": {
      "hex": "#692F08",
      "alpha": 255
    },
    "86": {
      "hex": "#6A563F",
      "alpha": 255
    },
    "87": {
      "hex": "#6A8EA0",
      "alpha": 255
    },
    "88": {
      "hex": "#6AA06E",
      "alpha": 255
    },
    "89": {
      "hex": "#6B6361",
      "alpha": 255
    },
    "90": {
      "hex": "#6E6E6E",
      "alpha": 255
    },
    "91": {
      "hex": "#6E867F",
      "alpha": 255
    },
    "92": {
      "hex": "#6E984D",
      "alpha": 255
    },
    "93": {
      "hex": "#6F6F6F",
      "alpha": 255
    },
    "94": {
      "hex": "#710CC7",
      "alpha": 255
    },
    "95": {
      "hex": "#711010",
      "alpha": 255
    },
    "96": {
      "hex": "#713F1D",
      "alpha": 255
    },
    "97": {
      "hex": "#723709",
      "alpha": 255
    },
    "98": {
      "hex": "#725D43",
      "alpha": 255
    },
    "99": {
      "hex": "#75BDBD",
      "alpha": 255
    },
    "100": {
      "hex": "#763B1A",
      "alpha": 255
    },
    "101": {
      "hex": "#765F43",
      "alpha": 255
    },
    "102": {
      "hex": "#794B11",
      "alpha": 255
    },
    "103": {
      "hex": "#796144",
      "alpha": 255
    },
    "104": {
      "hex": "#7DA269",
      "alpha": 255
    },
    "105": {
      "hex": "#7F4D36",
      "alpha": 255
    },
    "106": {
      "hex": "#80DBDA",
      "alpha": 255
    },
    "107": {
      "hex": "#8119B7",
      "alpha": 255
    },
    "108": {
      "hex": "#825032",
      "alpha": 255
    },
    "109": {
      "hex": "#826849",
      "alpha": 255
    },
    "110": {
      "hex": "#83C790",
      "alpha": 255
    },
    "111": {
      "hex": "#853217",
      "alpha": 255
    },
    "112": {
      "hex": "#855114",
      "alpha": 255
    },
    "113": {
      "hex": "#85561E",
      "alpha": 255
    },
    "114": {
      "hex": "#856F56",
      "alpha": 255
    },
    "115": {
      "hex": "#86581E",
      "alpha": 255
    },
    "116": {
      "hex": "#868377",
      "alpha": 255
    },
    "117": {
      "hex": "#897A70",
      "alpha": 255
    },
    "118": {
      "hex": "#8B532C",
      "alpha": 255
    },
    "119": {
      "hex": "#8C0D5B",
      "alpha": 255
    },
    "120": {
      "hex": "#8D8D8D",
      "alpha": 255
    },
    "121": {
      "hex": "#8EA59F",
      "alpha": 255
    },
    "122": {
      "hex": "#8F0F69",
      "alpha": 255
    },
    "123": {
      "hex": "#8F8254",
      "alpha": 255
    },
    "124": {
      "hex": "#917656",
      "alpha": 255
    },
    "125": {
      "hex": "#933709",
      "alpha": 255
    },
    "126": {
      "hex": "#949593",
      "alpha": 255
    },
    "127": {
      "hex": "#988880",
      "alpha": 255
    },
    "128": {
      "hex": "#997C59",
      "alpha": 255
    },
    "129": {
      "hex": "#998475",
      "alpha": 255
    },
    "130": {
      "hex": "#999999",
      "alpha": 255
    },
    "131": {
      "hex": "#9A8E8B",
      "alpha": 255
    },
    "132": {
      "hex": "#9B166D",
      "alpha": 255
    },
    "133": {
      "hex": "#9B6F4D",
      "alpha": 255
    },
    "134": {
      "hex": "#9BBC88",
      "alpha": 255
    },
    "135": {
      "hex": "#9BE0E0",
      "alpha": 255
    },
    "136": {
      "hex": "#9FC0AB",
      "alpha": 255
    },
    "137": {
      "hex": "#A32375",
      "alpha": 255
    },
    "138": {
      "hex": "#A39797",
      "alpha": 255
    },
    "139": {
      "hex": "#A48560",
      "alpha": 255
    },
    "140": {
      "hex": "#A49681",
      "alpha": 255
    },
    "141": {
      "hex": "#A4A3A0",
      "alpha": 255
    },
    "142": {
      "hex": "#A58D8D",
      "alpha": 255
    },
    "143": {
      "hex": "#A66E2C",
      "alpha": 255
    },
    "144": {
      "hex": "#A77C47",
      "alpha": 255
    },
    "145": {
      "hex": "#A98C6B",
      "alpha": 255
    },
    "146": {
      "hex": "#AA7B54",
      "alpha": 255
    },
    "147": {
      "hex": "#AD2160",
      "alpha": 255
    },
    "148": {
      "hex": "#AD7E59",
      "alpha": 255
    },
    "149": {
      "hex": "#AE8B61",
      "alpha": 255
    },
    "150": {
      "hex": "#AF2C7B",
      "alpha": 255
    },
    "151": {
      "hex": "#AF38A1",
      "alpha": 255
    },
    "152": {
      "hex": "#AFA3A3",
      "alpha": 255
    },
    "153": {
      "hex": "#B03285",
      "alpha": 255
    },
    "154": {
      "hex": "#B0A39B",
      "alpha": 255
    },
    "155": {
      "hex": "#B1B1B1",
      "alpha": 255
    },
    "156": {
      "hex": "#B261DC",
      "alpha": 255
    },
    "157": {
      "hex": "#B38E7D",
      "alpha": 255
    },
    "158": {
      "hex": "#B4B4B4",
      "alpha": 255
    },
    "159": {
      "hex": "#B66F4E",
      "alpha": 255
    },
    "160": {
      "hex": "#B69F82",
      "alpha": 255
    },
    "161": {
      "hex": "#B6A389",
      "alpha": 255
    },
    "162": {
      "hex": "#B6B4BF",
      "alpha": 255
    },
    "163": {
      "hex": "#B7AB98",
      "alpha": 255
    },
    "164": {
      "hex": "#B8B4AC",
      "alpha": 255
    },
    "165": {
      "hex": "#B9B9B9",
      "alpha": 128
    },
    "166": {
      "hex": "#BAACA2",
      "alpha": 255
    },
    "167": {
      "hex": "#BBB3A6",
      "alpha": 255
    },
    "168": {
      "hex": "#BD47B0",
      "alpha": 255
    },
    "169": {
      "hex": "#C13F8F",
      "alpha": 255
    },
    "170": {
      "hex": "#C28946",
      "alpha": 255
    },
    "171": {
      "hex": "#C42110",
      "alpha": 255
    },
    "172": {
      "hex": "#C6C6C6",
      "alpha": 255
    },
    "173": {
      "hex": "#C77514",
      "alpha": 255
    },
    "174": {
      "hex": "#C8FBFB",
      "alpha": 255
    },
    "175": {
      "hex": "#C9B2B2",
      "alpha": 255
    },
    "176": {
      "hex": "#C9C9C9",
      "alpha": 255
    },
    "177": {
      "hex": "#CA4E11",
      "alpha": 255
    },
    "178": {
      "hex": "#CAC9D4",
      "alpha": 255
    },
    "179": {
      "hex": "#CAD6E1",
      "alpha": 255
    },
    "180": {
      "hex": "#CD00CB",
      "alpha": 255
    },
    "181": {
      "hex": "#CFBDA6",
      "alpha": 255
    },
    "182": {
      "hex": "#D09C6E",
      "alpha": 255
    },
    "183": {
      "hex": "#D29D60",
      "alpha": 255
    },
    "184": {
      "hex": "#D4C8B8",
      "alpha": 255
    },
    "185": {
      "hex": "#D60000",
      "alpha": 255
    },
    "186": {
      "hex": "#D60404",
      "alpha": 255
    },
    "187": {
      "hex": "#D7D7D7",
      "alpha": 255
    },
    "188": {
      "hex": "#DA8E66",
      "alpha": 255
    },
    "189": {
      "hex": "#DACDBB",
      "alpha": 255
    },
    "190": {
      "hex": "#DBB180",
      "alpha": 255
    },
    "191": {
      "hex": "#DC1D1D",
      "alpha": 255
    },
    "192": {
      "hex": "#DCD8A4",
      "alpha": 255
    },
    "193": {
      "hex": "#DCDCDC",
      "alpha": 255
    },
    "194": {
      "hex": "#DCDFEA",
      "alpha": 255
    },
    "195": {
      "hex": "#DDBEBA",
      "alpha": 255
    },
    "196": {
      "hex": "#DDDDDD",
      "alpha": 128
    },
    "197": {
      "hex": "#DFDFDF",
      "alpha": 255
    },
    "198": {
      "hex": "#E08282",
      "alpha": 255
    },
    "199": {
      "hex": "#E22626",
      "alpha": 255
    },
    "200": {
      "hex": "#E25B26",
      "alpha": 255
    },
    "201": {
      "hex": "#E4EB17",
      "alpha": 255
    },
    "202": {
      "hex": "#E65700",
      "alpha": 255
    },
    "203": {
      "hex": "#E6AEAE",
      "alpha": 255
    },
    "204": {
      "hex": "#E7CBA9",
      "alpha": 255
    },
    "205": {
      "hex": "#E86570",
      "alpha": 255
    },
    "206": {
      "hex": "#E8EFC0",
      "alpha": 255
    },
    "207": {
      "hex": "#E8F4FF",
      "alpha": 255
    },
    "208": {
      "hex": "#EAD9D9",
      "alpha": 255
    },
    "209": {
      "hex": "#EEEAB6",
      "alpha": 255
    },
    "210": {
      "hex": "#EEEEEE",
      "alpha": 255
    },
    "211": {
      "hex": "#F0F0F0",
      "alpha": 255
    },
    "212": {
      "hex": "#FD3232",
      "alpha": 255
    },
    "213": {
      "hex": "#FF0000",
      "alpha": 255
    },
    "214": {
      "hex": "#FF2A00",
      "alpha": 255
    },
    "215": {
      "hex": "#FF8EBE",
      "alpha": 255
    },
    "216": {
      "hex": "#FFBA00",
      "alpha": 255
    },
    "217": {
      "hex": "#FFC926",
      "alpha": 255
    },
    "218": {
      "hex": "#FFD800",
      "alpha": 255
    },
    "219": {
      "hex": "#FFD926",
      "alpha": 255
    },
    "220": {
      "hex": "#FFF68E",
      "alpha": 255
    },
    "221": {
      "hex": "#FFFFFF",
      "alpha": 255
    }
  }
}